import React from 'react';
import { Navbar } from 'react-bulma-components';
import LangSelector from './LangSelector';
import './NavSecondary.scss';
import { useMedia } from '../../../shared/hooks';
import { useActiveLanguageCode } from '../../../i18n/LanguageProvider';
import StatEEHeaderSocial from './StatEEHeaderSocial';

const NavSecondary = () => {
  const isMobile = useMedia(['(max-width: 768px)', '(min-width: 769px)'], [true, false], false);
  const isTablet = useMedia(['(max-width: 1023px)', '(max-width: 769px)'], [true, false], false);
  const language = useActiveLanguageCode();

  return (
    <div className="navbar-wrapper navbar-secondary">
      <div className="content-link">
        <a href="#main" tabIndex="1">
          Liigu edasi põhisisu juurde
        </a>
      </div>

      <div className="u-container">
        <Navbar color={'dark'} aria-label="links navigation" className="navbar-secondary">
          <Navbar.Menu>
            <Navbar.Container>
              <stat-ee-header-apps data-app="juhtimislauad" data-lang={language}></stat-ee-header-apps>
            </Navbar.Container>

            <Navbar.Container style={{ justifyContent: 'center' }}>
              <StatEEHeaderSocial language={language} addSocial={!isMobile && !isTablet} />
            </Navbar.Container>

            {!isMobile && !isTablet && (
              <>
                <Navbar.Container position="end">
                  <Navbar.Item>
                    <LangSelector />
                  </Navbar.Item>
                </Navbar.Container>
              </>
            )}
          </Navbar.Menu>
        </Navbar>
      </div>
    </div>
  );
};

export default NavSecondary;
